<template>
	<div class="his-order-list-div">
		<van-empty v-if="history.length==0" :description="orderCtx" />
		<div v-for="(item,index) in history" :key="index">
			<div class="his-shop-div">
				<van-row type="flex" justify="space-between">
					<van-col span="16">
						<div class="his-shop-name">
							<img src="../../assets/shop.png">
							<span>{{item.orderType == 1?item.storeName:'星巴克中杯通兑券'}}</span>
						</div>
					</van-col>
					<van-col span="8">
						<div class="his-status">
							<!-- {{item.status|orderStatusFilter(item.createdTime)}} -->
							{{item.statusName}}
						</div>
					</van-col>
				</van-row>

				<van-row type="flex" justify="space-between">
					<van-col span="8">
						<div class="his-order-detail-left">
							订单编号:
						</div>
					</van-col>
					<van-col span="16">
						<div class="his-order-detail-right">
							{{item.orderNo}}
						</div>
					</van-col>
				</van-row>

				<van-row type="flex" justify="space-between">
					<van-col span="8">
						<div class="his-order-detail-left">
							下单时间:
						</div>
					</van-col>
					<van-col span="16">
						<div class="his-order-detail-right">
							{{item.createdTime}}
						</div>
					</van-col>
				</van-row>
				<div class="his-order-goods-div" v-if="item.orderType == 1">
					<div v-for="(subItem,subIndex) in item.starSubOrders" :key="subIndex">
						<van-row type="flex">
							<van-col span="6">
								<img class="his-goods-image" :src="subItem.thumb" />
							</van-col>
							<van-col span="14">
								<div class="his-goods-name-div">{{subItem.goodsName}}</div>
								<div class="his-goods-spec-div">{{subItem.goodsSpec}}</div>
							</van-col>
							<van-col span="4">
								<div class="his-goods-count-div">x{{subItem.goodsNum}}</div>
							</van-col>
						</van-row>
					</div>
				</div>
				<div class="his-order-goods-div" v-else>
					
						<van-row type="flex">
							<van-col span="6">
								<div class="starbucks-box">
									<img class="his-goods-image" src="@/assets/xingbake.png" />
								</div>
							</van-col>
							<van-col span="14">
								<div class="his-goods-name-div">星巴克中杯通兑券</div>
								<div class="his-goods-spec-div"></div>
							</van-col>
							<van-col span="4">
								<div class="his-goods-count-div">x1</div>
							</van-col>
						</van-row>
					
				</div>
				<div class="his-order-price-div">
					<van-row type="flex" justify="space-between">
						<van-col span="10">
							<div class="his-order-close-timer" v-if="item.status == 0  && getCloseTime(item.createdTime)>0">
								<van-count-down :time="getCloseTime(item.createdTime)" format="mm分ss秒后失效" />
							</div>
						</van-col>
						<van-col span="14">
							<div class="his-order-price">
								<span>总价：</span>
								<span>¥</span>
								<span>{{parseFloat(item.totalAmount+'').toFixed(2)}}</span>
							</div>
						</van-col>
					</van-row>
				</div>
				<div class="order-code-btn" v-if="item.status == 0 && getCloseTime(item.createdTime)>0">
					<van-button round text="去支付" @click="showPay(item.orderId,code)" color="#006e3f" />
				</div>
				<div class="order-code-btn" v-if="item.status >0 && item.status<5">
					<van-button round :text="item.orderType == 1?'取餐口令':'查看二维码'" @click="toOrderDetail(item.orderId,item.orderType)" color="#006e3f" />
				</div>
				<div class="order-code-btn" v-if="item.status == 5 || item.status == 6">
					<van-button round plain :text="item.status == 5?'退款中':'已退款'" type="danger" />
				</div>
			</div>
		</div>

		<van-action-sheet v-model="showPayType" :round="false" :closeable="false">
			<PayType :orderId="orderId" :code="code" @loadCode = "doLoadCode"></PayType>
		</van-action-sheet>
	</div>
</template>

<script>
	import {
		Col,
		Row,
		Button,
		CountDown,
		Empty,
		ActionSheet
	} from 'vant';
	import {
		mapState,
		mapGetters,
		mapMutations,
		mapActions
	} from "vuex";
	import {
		getHistoryOrder,
		getWeixinPay,

	} from '@/request/api';
	import PayType from '../pay/PayType.vue'
	export default {
		name: 'OrderList',
		components: {
			[Col.name]: Col,
			[Row.name]: Row,
			[Button.name]: Button,
			[CountDown.name]: CountDown,
			[Empty.name]: Empty,
			[PayType.name]: PayType,
			[ActionSheet.name]: ActionSheet
		},
		props: ['code'],
		data() {
			return {
				showPayType:false,
				history: [],
				orderId:'',
				// orderCtx:"暂无订单"
				orderCtx:"加载中"
			}
		},
		created() {
			this.getOrderList();
		},
		methods: {
			...mapMutations(['setOrderId']),
			getOrderList() {
				getHistoryOrder({}).then(res => {
					res.forEach(item =>{
						if(item.id){
							item.starSubOrders.forEach(childItem =>{
								childItem.goodsId = childItem.foodId;
								childItem.goodsName = childItem.foodName;
								childItem.goodsNum = childItem.foodNum;
								childItem.goodsSpec = childItem.specification;
								childItem.thumb = childItem.thumb;
							})
						}
					})
					this.history = res
					if(this.history.length==0){
						this.orderCtx = "暂无订单"
					}
				})
			},
			showPay(orderId) {
				// console.log(orderId)
				// toOrderDetail(orderId) {
					// this.setOrderId(orderId);
					this.$router.push({
						name: 'OrderPay',
						query: {
							orderId: orderId
						}
					})
				// }
				// this.orderId = orderId;
				// this.showPayType = true;
			},
			getCloseTime(createdTime) {
				let now = new Date().getTime();
				createdTime = new Date(Date.parse(createdTime.replace(/-/g, "/"))).getTime();
				return 10 * 60 * 1000 - (now - createdTime)
			},
			doLoadCode(){
				this.$emit('loadCode')
			},
			toOrderDetail(orderId,orderType) {
				this.setOrderId(orderId);
				this.$router.push({
					name: 'orderDetail',
					params: {
						orderId: orderId
					}
				})
			}
		},
		filters: {
			orderStatusFilter: function(status, createdTime) {
				let msg = '';
				switch (status) {
					case 0:
						msg = "去支付"
						break
					case 1:
						msg = "下单中"
						break
					case 2:
						msg = "下单中"
						break
					case 3:
						msg = "已下单"
						break
					case 4:
						msg = "已下单"
						break
					case 5:
						msg = "下单失败"
						break
					case 6:
						msg = "已退款"
						break
					case 7:
						msg = "已失效"
						break
				}
				if (status == 0) {
					let now = new Date().getTime();
					createdTime = new Date(createdTime).getTime();
					if (now - createdTime >= 10 * 60 * 1000) {
						return '已取消';
					}
				}
				return msg;
			}
		}
	}
</script>

<style scoped>
	.his-order-list-div {
		width: 100%;
		min-height: 100%;
		overflow-y: auto;
	}

	.his-shop-name,
	his-status {
		padding: 0px 0px 10px 0px;
	}

	.his-shop-name>img {
		width: 13px;
		height: 13px;
		margin-right: 3px;
	}

	.his-order-list-div>div {
		margin-top: 15px;
		padding: 15px;
		background-color: #ffffff;
	}

	.his-order-list-div .van-empty {
		padding-top: 40px;
		background-color: #f6f6f6;
	}

	.his-order-price-div {
		padding: 10px 0px;
	}

	.his-shop-name {
		display: inline-flex;
		align-items: center;
		font-size: 15px;
		color: #2f2f2f;
		font-weight: 550;
	}

	.his-status {
		text-align: right;
		font-size: 13px;
		color: #343434;
	}

	.his-order-detail-left {
		color: #666666;
		font-size: 13px;
	}

	.his-order-detail-right {
		text-align: right;
		color: #666666;
		font-size: 13px;
	}

	.his-order-goods-div {
		padding: 10px 0px;
		border-bottom: dashed 1px #e7e7e7;
	}

	.his-goods-count-div {
		text-align: right;
		padding-top: 35px;
	}

	.his-goods-image {
		width: 80px;
		height: 80px;
	}

	.his-goods-name-div {
		padding-top: 15px;
		font-size: 15px;
		color: #2f2f2f;
		font-weight: 600;
	}

	.his-goods-spec-div {
		font-size: 13px;
		color: #666666;
	}

	.his-goods-count-div {
		font-size: 14px;
		color: #2f2f2f;
	}

	.his-order-price {
		text-align: right;
	}

	.his-order-price span:nth-child(1) {
		font-size: 14px;
	}

	.his-order-price span:nth-child(2) {
		padding: 15px 0px;
		color: #c04733;
		font-size: 12px;
	}

	.his-order-price span:nth-child(3) {
		color: #c04733;
		font-size: 14px;
	}

	.order-code-btn {
		text-align: right;
	}

	.order-code-btn button {
		padding: 4px 8px;
		height: 30px;
		width: auto;
	}
	.starbucks-box{
		padding: 15px;
		
	}
	.starbucks-box img{
		width: 50px;
		height: 50px;
	}
</style>
